import { requestWithToken } from '../utilities/request';

const path = '/api/private/external_service_cooperation_status';

const get_list = params => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/list`),
    params,
  });
};
const get_list_options = params => {
  return {
    method: 'GET',
    url: path.concat(`/list`),
    params,
  }
}

const get_list_default_response = () => {
  return {
    "result": true,
    "status": 0,
    "message": "",
    "data": {
      "total": 2,
      "entities": {
        "line_works":
        {
          "available": false,
          "reason_code": -1
        },
        "direct":
        {
          "available": false,
          "reason_code": -1
        }
      }
    }
  }
}

const list = {
  get: get_list,
  get_options: get_list_options,
  get_default_response: get_list_default_response,
}

export const ExternalServiceCooperationStatusApi = {
  list,
};

export default ExternalServiceCooperationStatusApi;



// WEBPACK FOOTER //
// ./src/services/ExternalServiceCooperationStatusApi.js